import React from 'react'
import Form from '@blocks/Form'
import { ReactComponent as EmailIcon } from '@icons/email.svg'
import { ReactComponent as PasswordIcon } from '@icons/password.svg'
import { Link } from 'react-router-dom'
import useTitle from '@hooks/useTitle'
import Button from '@components/blocks/Button'
import Input from '@components/blocks/Input'
import useAuthTemplate from '@auth/components/template/hooks/useAuthTemplate'
import { route } from '@helpers'
import api from '@api'
import useAuth from '@hooks/useAuth'

export default function SignupPage() {
    const { setUser } = useAuth()
    
    useTitle("Registration")
    useAuthTemplate({
        social: true,
        description: "You need to register only once and you will have access to all salons in one profile.",
        footer: <p><Link to={route("signin")}>Sign in</Link><span> if you have an account already</span></p>
    })

    return (
        <Form action={api.register} handleSuccess={setUser} method="post">
            <Input id="email" name="email" type="email" height="l" placeholder="example@email.com" label="Email" required icon={<EmailIcon />} />
            <Input minLength={8} id="password" name="password" height="l" type="password" placeholder="xxxxxxxx" label="Password" required icon={<PasswordIcon />} />
            <Input minLength={8} id="password_confirmation" height="l" name="password_confirmation" type="password" placeholder="xxxxxxxx" label="Repeat password" required icon={<PasswordIcon />} />
            <Button element="submit">Sign up</Button>
        </Form>
    )
}